(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-downloads"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-product-downloads')) {
    class BruunmunchProductDownloads extends HTMLElement {
      connectedCallback() {
        this.accordion = this.closest('details');
        this.buttons = [...this.querySelectorAll('[data-bm-model-format]')];
        this.status = this.querySelector('[data-bm-download-status]');
        try { this.variants = JSON.parse(this.querySelector('[data-bm-download-variants]')?.textContent || '{}'); }
        catch { this.variants = {}; }
        this.generation = 0;
        this.sync = this.sync.bind(this);
        this.click = this.click.bind(this);
        this.toggle = () => { if (this.accordion?.open) this.sync(true); };
        this.accordion?.addEventListener('toggle', this.toggle);
        this.addEventListener('click', this.click);
        window.addEventListener('popstate', this.sync);
        this.timer = window.setInterval(this.sync, 150);
        this.sync();
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.controller?.abort();
        this.generation++;
        this.accordion?.removeEventListener('toggle', this.toggle);
        this.removeEventListener('click', this.click);
        window.removeEventListener('popstate', this.sync);
      }
      selectedVariant() {
        const form = document.getElementById(this.dataset.formId);
        return new URL(location.href).searchParams.get('variant') || form?.elements.namedItem('id')?.value || this.dataset.initialVariant;
      }
      sync(force = false) {
        const id = String(this.selectedVariant() || '');
        if (id === this.variantId && force !== true) return;
        this.variantId = id;
        const specLink = this.querySelector('[data-bm-dynamic-spec]');
        if (specLink) { const url = new URL(specLink.href); url.searchParams.set('variant', id); specLink.href = url.href; }
        this.controller?.abort();
        this.controller = new AbortController();
        this.generation++;
        this.buttons.forEach(button => { button.disabled = true; delete button.dataset.url; });
        if (this.status) this.status.textContent = '';
        if (this.accordion?.open && this.buttons.length) this.check(this.generation);
      }
      modelURL(format) {
        const variant = this.variants[this.variantId];
        if (!variant?.code) return null;
        let features = variant.features;
        try { if (typeof features === 'string') features = JSON.parse(features); }
        catch { return null; }
        if (!features || typeof features !== 'object' || Array.isArray(features)) return null;
        const name = (variant.sku || variant.code).replace(/[^a-zA-Z0-9_-]/g, '-');
        const url = new URL(`https://content.cylindo.com/api/v2/9069/products/${encodeURIComponent(variant.code)}/AR/${encodeURIComponent(name)}.${format}`);
        for (const [feature, option] of Object.entries(features)) url.searchParams.append('feature', `${feature}:${option}`);
        url.searchParams.set('polymodel', 'high');
        url.searchParams.set('materiallevelofdetail', '2');
        return url.href;
      }
      async check(generation) {
        this.status.textContent = this.dataset.checking;
        const signal = this.controller.signal;
        await Promise.allSettled(this.buttons.map(async button => {
          const url = this.modelURL(button.dataset.bmModelFormat);
          if (!url) return;
          const response = await fetch(url, { method: 'HEAD', signal: AbortSignal.any([signal, AbortSignal.timeout(15000)]) });
          if (generation !== this.generation || !this.isConnected) return;
          if (response.status === 200) { button.dataset.url = url; button.disabled = false; }
        }));
        if (generation !== this.generation || !this.isConnected) return;
        this.status.textContent = this.buttons.some(button => !button.disabled) ? '' : this.dataset.unavailable;
      }
      async click(event) {
        const button = event.target.closest('[data-bm-model-format]');
        if (!button || button.disabled || !button.dataset.url) return;
        this.sync();
        if (button.disabled || !button.dataset.url) return;
        const generation = this.generation;
        button.disabled = true;
        this.status.textContent = this.dataset.preparing;
        try {
          const response = await fetch(button.dataset.url, { signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(120000)]) });
          if (response.status !== 200) throw new Error('Download unavailable');
          const blob = await response.blob();
          if (generation !== this.generation || !this.isConnected) return;
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          let filename = decodeURIComponent(new URL(button.dataset.url).pathname.split('/').pop());
          if (/zip/i.test(response.headers.get('content-type') || '')) filename += '.zip';
          link.download = filename;
          document.body.append(link);
          link.click();
          link.remove();
          window.setTimeout(() => URL.revokeObjectURL(url), 60000);
          this.status.textContent = '';
        } catch (error) {
          if (generation === this.generation && this.isConnected) this.status.textContent = this.dataset.error;
        } finally {
          if (generation === this.generation && this.isConnected) button.disabled = false;
        }
      }
    }
    customElements.define('bm-product-downloads', BruunmunchProductDownloads);
  }
  } catch(e) { console.error(e); }
})();

})();
